import { render, staticRenderFns } from "./postManagement.vue?vue&type=template&id=fa0cf006&scoped=true"
import script from "./postManagement.vue?vue&type=script&lang=js"
export * from "./postManagement.vue?vue&type=script&lang=js"
import style0 from "./postManagement.vue?vue&type=style&index=0&id=fa0cf006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0cf006",
  null
  
)

export default component.exports